import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./header.css";

const Header = () => {
  /*=============== Change Background Header ===============*/
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    if (this.scrollY >= 80) header.classList.add("scroll-header");
    else header.classList.remove("scroll-header");
  });

  /*=============== Toggle Menu ===============*/
  const [Toggle, ShowMenu] = useState(false);
  const [activeNav, setActiveNav] = useState("#home");
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (hash) => {
    setActiveNav(hash);
    if (location.pathname === "/") {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/${hash}`);
    }
    ShowMenu(false);
  };

  return (
    <header className="header">
      <nav className="nav container">
        <a href="/" className="nav__logo">
          LUKAS
        </a>

        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav_item">
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#home");
                }}
                className={
                  activeNav === "#home" ? "nav_link active-link" : "nav_link"
                }
              >
                <i className="uil uil-estate nav_icon"></i> Home
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#about");
                }}
                className={
                  activeNav === "#about" ? "nav_link active-link" : "nav_link"
                }
              >
                <i className="uil uil-user nav_icon"></i> About
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#skills"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#skills");
                }}
                className={
                  activeNav === "#skills" ? "nav_link active-link" : "nav_link"
                }
              >
                <i className="uil uil-file-alt nav_icon"></i> Skills
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#services");
                }}
                className={
                  activeNav === "#services"
                    ? "nav_link active-link"
                    : "nav_link"
                }
              >
                <i className="uil uil-briefcase-alt nav_icon"></i> Service
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#qualification"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#qualification");
                }}
                className={
                  activeNav === "#qualification"
                    ? "nav_link active-link"
                    : "nav_link"
                }
              >
                <i className="uil uil-scenery nav_icon"></i> Qualification
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#portfolio"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#portfolio");
                }}
                className={
                  activeNav === "#portfolio"
                    ? "nav_link active-link"
                    : "nav_link"
                }
              >
                <i className="uil uil-scenery nav_icon"></i> Portfolio
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#contact");
                }}
                className={
                  activeNav === "#contact"
                    ? "nav_link active-link"
                    : "nav_link"
                }
              >
                <i className="uil uil-message nav_icon"></i> Contact
              </a>
            </li>

            <li className="nav_item">
              <a
                href="#blog"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#blog");
                }}
                className={
                  activeNav === "#blog" ? "nav_link active-link" : "nav_link"
                }
              >
                <i className="uil uil-notes nav_icon"></i> Blog
              </a>
            </li>
          </ul>

          {/* ✅ FIXED CLOSE ICON */}
          <i
            className="uil uil-times nav__close"
            onClick={() => ShowMenu(false)}
          ></i>
        </div>

        {/* ✅ FIXED TOGGLE ICON */}
        <div className="nav__toggle" onClick={() => ShowMenu(true)}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;
